import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCc = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 72 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 21)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M61.53 6a2.996 2.996 0 012.863 2.105h0l4.47 14.305a3 3 0 01.137.895h0V31c0 .552-.224 1.052-.586 1.414A1.994 1.994 0 0167 33h0-2.07a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0158 39a6.977 6.977 0 01-4.856-1.958 6.98 6.98 0 01-2.14-4.8h0L51 8c0-.552.224-1.052.586-1.414A1.994 1.994 0 0153 6h0z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0D0E10",
				d: "M57 7h2v13h-2zM52 20h16v2H52z"
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 58,
				cy: 33,
				r: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 10,
				cy: 33,
				r: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M51-1v34H16.93a6.98 6.98 0 01-1.98 3.95A6.978 6.978 0 0110 39a6.977 6.977 0 01-4.856-1.958 6.985 6.985 0 01-2.048-3.882h0L.956 33a1.994 1.994 0 01-1.37-.586A1.994 1.994 0 01-1 31h0v-4h48V1c0-.552.224-1.052.586-1.414A1.994 1.994 0 0149-1h2z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.54 3a2 2 0 011.398.57h0l5.445 6.34 9.2 2.921a1.997 1.997 0 011.41 1.744h0L41 18a1.997 1.997 0 01-1.834 1.993h0L36.744 20A4.506 4.506 0 0132.5 23a4.506 4.506 0 01-4.243-3h0-14.514A4.506 4.506 0 019.5 23a4.506 4.506 0 01-4.243-3h0H4a1.997 1.997 0 01-1.993-1.835h0L2 10.014l3.863-6.112a2 2 0 011.496-.894h0z",
				stroke: "#0D0E10",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 9.5,
				cy: 18.5,
				r: 1.5
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 32.5,
				cy: 18.5,
				r: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#0D0E10",
				d: "M12.5 9.5h17v1h-17z"
			}),
			/* @__PURE__ */ _jsx("path", {
				stroke: "#0D0E10",
				d: "M12.5 4.5h1v6h-1zM17.5 4.5h1v6h-1z"
			})
		]
	})
});
export default SvgCc;
